// @ts-nocheck
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useMantineTheme, useMantineColorScheme } from '@mantine/core';
import { Anchor, Badge, Box, Button, Checkbox, Container, Stack, Text, Title } from '@/components/ui';
import { IconArrowLeft, IconDeviceMobile } from '@tabler/icons-react';
import { FadeIn } from '@/components/animations';
import { MobileTextInput, MobilePasswordInput, SocialLoginButtons } from '../components';

export default function ForgotMobileAppStyle() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const theme = useMantineTheme();
  const { colorScheme } = useMantineColorScheme();
  const isDark = colorScheme === 'dark';

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Login:', { email, password, rememberMe });
  };

  return (
    <Box
      style={{
        minHeight: '100vh',
        backgroundColor: isDark ? theme.colors.dark[7] : '#F5F7FA',
        padding: '1.5rem',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Container size="xs" w="100%">
        <FadeIn>
          <Stack gap="xl">
            <Button
              component={Link}
              to="/demo/auth-pages/forgot-password"
              variant="subtle"
              size="xs"
              leftSection={<IconArrowLeft size={14} />}
              w="fit-content"
            >
              Back to variants
            </Button>

            <Stack gap="xs" align="center">
              <Badge
                leftSection={<IconDeviceMobile size={12} />}
                variant="gradient"
                gradient={{ from: 'blue', to: 'cyan' }}
                size="lg"
              >
                Mobile App Style
              </Badge>
              <Title order={2} ta="center" mt="md">
                Forgot password?
              </Title>
              <Text c="dimmed" size="sm" ta="center">
                Enter your email to reset your password
              </Text>
            </Stack>

            <form onSubmit={handleSubmit}>
              <Stack gap="lg">
                <MobileTextInput
                  label="Email"
                  placeholder="you@example.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />

                <MobilePasswordInput
                  label="Password"
                  placeholder="Your password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />

                <Checkbox
                  label="Remember me"
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.currentTarget.checked)}
                />

                <Button
                  type="submit"
                  fullWidth
                  size="xl"
                  radius="xl"
                  gradient={{ from: 'blue', to: 'cyan' }}
                  variant="gradient"
                  style={{ minHeight: 56 }}
                >
                  Sign in
                </Button>
              </Stack>
            </form>

            <Stack gap="md">
              <Text ta="center" size="sm" c="dimmed">
                Or continue with
              </Text>
              <SocialLoginButtons providers={['google', 'apple']} layout="row" />
            </Stack>

            <Stack gap="sm" align="center">
              <Anchor component={Link} to="/demo/auth-pages/forgot-password/mobile-app-style" size="sm">
                Forgot password?
              </Anchor>
              <Text size="sm" c="dimmed">
                Don't have an account?{' '}
                <Anchor component={Link} to="/demo/auth-pages/register/mobile-app-style" fw={500}>
                  Sign up
                </Anchor>
              </Text>
            </Stack>
          </Stack>
        </FadeIn>
      </Container>
    </Box>
  );
}
